var _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionTimeout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0423 43.167C11.0423 43.167 10.8178 43.007 10.459 42.7327C5.08365 38.5765 1.71484 32.5535 1.71484 25.8481C1.71484 13.3473 13.469 3.20309 27.959 3.20309C42.455 3.20309 54.215 13.3473 54.215 25.8481C54.215 38.3548 42.461 48.149 27.965 48.149C26.728 48.149 24.6982 48.067 21.8748 47.904C18.194 50.296 15.8215 55.259 11.1198 55.259C9.66444 55.259 8.97905 54.063 9.91235 52.844C11.3298 51.105 10.284 45.32 11.0423 43.164V43.167Z",
    stroke: "#45504D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6965 38.9688V37.6911L17.7774 30.5618H12.6865V28.7869H20.482V30.0646L15.396 37.1939H20.4919V38.9688H12.6965Z",
    fill: "#45504D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0841 34.2656V32.6229L28.617 23.4567H22.0713V21.1747H32.094V22.8175L25.555 31.9837H32.107V34.2656H22.0841Z",
    fill: "#45504D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8343 28.5V26.8572L40.3673 17.6911H33.8213V15.4091H43.8443V17.0518L37.3053 26.218H43.8573V28.5H33.8343Z",
    fill: "#45504D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0423 41.1673C15.0423 41.1673 14.8178 41.0069 14.459 40.7327C9.08365 36.5765 5.71484 30.5535 5.71484 23.8481C5.71484 11.3473 17.469 1.20309 31.959 1.20309C46.455 1.20309 58.215 11.3473 58.215 23.8481C58.215 36.3548 46.461 46.149 31.965 46.149C30.728 46.149 28.698 46.067 25.8748 45.904C22.194 48.296 19.8215 53.259 15.1198 53.259C13.6644 53.259 12.979 52.063 13.9123 50.844C15.3298 49.105 14.284 43.32 15.0423 41.1644V41.1673Z",
    stroke: "#45504D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6965 36.9688V35.6911L21.7774 28.5618H16.6865V26.7869H24.482V28.0646L19.396 35.1939H24.4919V36.9688H16.6965Z",
    fill: "#45504D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0838 32.2656V30.6229L32.6168 21.4567H26.0708V19.1747H36.0938V20.8175L29.5548 29.9837H36.1068V32.2656H26.0838Z",
    fill: "#45504D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8338 26.5V24.8572L44.3668 15.6911H37.8208V13.4091H47.8438V15.0518L41.3048 24.218H47.8568V26.5H37.8338Z",
    fill: "#45504D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimeout);
export default __webpack_public_path__ + "static/media/session-timeout.a9d387e241f397ea60c529d46ca77849.svg";
export { ForwardRef as ReactComponent };